import React from 'react';

// Redux
import { useSelector } from 'react-redux';

// Hooks
import { Link } from 'react-router-dom';

// MUI Components
import { Box, Typography, TextField, InputAdornment, IconButton } from '@mui/material';

// Utils
import { balanceFormatter } from '~/utils/helperFunctions';
import { MESSAGES } from '~/utils/message';

// Icons
import { PropertyLockCIcon } from '~/assets/images';
import CloseIcon from '@mui/icons-material/Close';

// Styles
import './styles.scss';

const PropertyTab = ({ propertyAddress, isEditing, setPropertyAddress, onUpdateContact }) => {
  const isPropertyAddressEnabled = useSelector(
    (state) =>
      state?.generalSettingsReducers?.generalSettings?.propertyAddressStrictness === 'Include' ||
      false
  );

  if (!isPropertyAddressEnabled) {
    return (
      <Box className="emptyTabContent">
        <img src={PropertyLockCIcon} alt="Property Lock" />
        <Typography variant="h6">{MESSAGES.CONTACTS.PROPERTY_TAB.PROPERTY_TAB_TITLE}</Typography>
        <Typography>{MESSAGES.CONTACTS.PROPERTY_TAB.PROPERTY_TAB_DESCRIPTION}</Typography>
        <Link className="olcPrimaryLink" to="/my-company">
          {MESSAGES.CONTACTS.PROPERTY_TAB.ENABLE_PROPERTY_ADDRESS}
        </Link>
      </Box>
    );
  }

  return (
    <>
      {isEditing ? (
        <form onSubmit={onUpdateContact}>
          <Box className="editFormLayout">
            <Box className="editFormRow">
              <Box className="editFormColumn">
                <Typography className="editFieldLabel">Property Address</Typography>
                <TextField
                  fullWidth
                  value={propertyAddress?.address}
                  onChange={(e) =>
                    setPropertyAddress((prev) => ({ ...prev, address: e.target.value }))
                  }
                  variant="outlined"
                  className="editTextField"
                  placeholder="Property Address"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ width: '16px', marginRight: '8px' }}>
                        {propertyAddress?.address && (
                          <IconButton
                            className="cpClearInputBtn"
                            size="small"
                            onClick={() => setPropertyAddress((prev) => ({ ...prev, address: '' }))}
                            edge="end"
                            sx={{ right: '15px' }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box className="editFormColumn">
                <Typography className="editFieldLabel">Property City</Typography>
                <TextField
                  fullWidth
                  value={propertyAddress?.city}
                  onChange={(e) =>
                    setPropertyAddress((prev) => ({ ...prev, city: e.target.value }))
                  }
                  variant="outlined"
                  className="editTextField"
                  placeholder="Property City"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ width: '16px', marginRight: '8px' }}>
                        {propertyAddress?.city && (
                          <IconButton
                            className="cpClearInputBtn"
                            size="small"
                            onClick={() => setPropertyAddress((prev) => ({ ...prev, city: '' }))}
                            edge="end"
                            sx={{ right: '15px' }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>
            <Box className="editFormRow">
              <Box className="editFormColumn">
                <Typography className="editFieldLabel">Property State</Typography>
                <TextField
                  fullWidth
                  value={propertyAddress?.state}
                  onChange={(e) =>
                    setPropertyAddress((prev) => ({ ...prev, state: e.target.value }))
                  }
                  variant="outlined"
                  className="editTextField"
                  placeholder="Property State"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ width: '16px', marginRight: '8px' }}>
                        {propertyAddress?.state && (
                          <IconButton
                            className="cpClearInputBtn"
                            size="small"
                            onClick={() => setPropertyAddress((prev) => ({ ...prev, state: '' }))}
                            edge="end"
                            sx={{ right: '15px' }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box className="editFormColumn">
                <Typography className="editFieldLabel">Property Zip Code</Typography>
                <TextField
                  fullWidth
                  value={propertyAddress?.zip}
                  onChange={(e) => setPropertyAddress((prev) => ({ ...prev, zip: e.target.value }))}
                  variant="outlined"
                  className="editTextField"
                  placeholder="Property Zip Code"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ width: '16px', marginRight: '8px' }}>
                        {propertyAddress?.zip && (
                          <IconButton
                            className="cpClearInputBtn"
                            size="small"
                            onClick={() => setPropertyAddress((prev) => ({ ...prev, zip: '' }))}
                            edge="end"
                            sx={{ right: '15px' }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>
          </Box>
        </form>
      ) : (
        <Box className="propertyTabContent">
          <Box className="propertyGrid">
            <Box className="propertyRow">
              <Box className="propertyColumn">
                <Typography className="propertyLabel">Property Address</Typography>
                <Typography className="propertyValue">{propertyAddress?.address || '-'}</Typography>
              </Box>
              <Box className="propertyColumn">
                <Typography className="propertyLabel">Property City</Typography>
                <Typography className="propertyValue">{propertyAddress?.city || '-'}</Typography>
              </Box>
            </Box>
            <Box className="propertyRow">
              <Box className="propertyColumn">
                <Typography className="propertyLabel">Property State</Typography>
                <Typography className="propertyValue">{propertyAddress?.state || '-'}</Typography>
              </Box>
              <Box className="propertyColumn">
                <Typography className="propertyLabel">Property Zip Code</Typography>
                <Typography className="propertyValue">{propertyAddress?.zip || '-'}</Typography>
              </Box>
            </Box>
            <Box className="propertyRow">
              <Box className="propertyColumn">
                <Typography className="propertyLabel">Property Offer</Typography>
                <Typography className="propertyValue">
                  {propertyAddress?.offer ? balanceFormatter(+propertyAddress.offer) : '-'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default PropertyTab;
